import { createMachine } from "xstate";

type TransitionEvent = { type: "enter" } | { type: "exit" } | { type: "next" };

export const transititionMachine = createMachine(
  {
    types: {} as { events: TransitionEvent },
    id: "transition",
    initial: "exited",
    states: {
      exited: {
        on: {
          enter: "entering",
        },
      },
      entering: {
        on: {
          next: "entered",
          exit: "exiting",
        },
        after: {
          transition: { target: "entered" },
        },
      },
      entered: {
        on: {
          exit: "exiting",
        },
      },
      exiting: {
        on: {
          next: "exited",
        },
        after: {
          transition: { target: "exited" },
        },
      },
    },
  },
  {
    delays: {
      transition: 240,
    },
  },
);
